import {Component} from "@angular/core";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {DialogComponent} from "../../bootstrap-modal/dialog.component";

export interface DisableOrderAcceptanceModel {
  message: string;
}

@Component({
  templateUrl: "./disable-order-acceptance-dialog.template.pug",
  providers: [
  ],
})
export class DisableOrderAcceptanceDialogComponent extends DialogComponent<DisableOrderAcceptanceModel, string>
  implements DisableOrderAcceptanceModel {
  message: string;
  error: Error;

  constructor(public dialogService: DialogService) {
    super(dialogService);
  }

  cancel(): void {
    this.result = null;
    this.close();
  }

  finish(): void {
    this.result = this.message && this.message.trim();
    if (!this.result) {
      this.error = new Error("A reason is required in order to disable order acceptance");
    } else {
      this.error = undefined;
      this.close();
    }
  }
}
